<span class="d-block">Item Number: {{itemNumber}}</span>
<span *ngIf="supplierId" class="d-block">{{supplierLabel}}:&nbsp;{{supplierId}}</span>
